import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-doc",
  "use": "icon-leo-doc-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-doc\">\r\n<g transform=\"translate(-61.440 -61.440) scale(1.120000)\">\r\n<path d=\"M256 128h384l128 128v640H256V128zm64 64v640h384V288H576V192H320z\" />\r\n  <path d=\"M384 416h256v48H384v-48zm0 112h256v48H384v-48zm0 112h160v48H384v-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-doc.svg
// module id = SvyN
// module chunks = 410